import { render } from "./EventsCard.vue?vue&type=template&id=4987cffc"
import script from "./EventsCard.vue?vue&type=script&lang=js"
export * from "./EventsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__